export const PRODUCTS_LINK = "https://on-geo.de/produkte/accumate/";
